import { render } from "./letter-compose.vue?vue&type=template&id=4a1f0ffb"
import script from "./letter-compose.vue?vue&type=script&lang=js"
export * from "./letter-compose.vue?vue&type=script&lang=js"

import "./letter-compose.vue?vue&type=style&index=0&id=4a1f0ffb&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__